var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"XMLID_5_","className":"st0","d":"M25.44,14.67c0-5.97-4.84-10.81-10.81-10.81S3.82,8.7,3.82,14.67c0,5.39,3.95,9.87,9.12,10.68\n\tV17.8H10.2v-3.12h2.74v-2.38c0-2.71,1.61-4.2,4.08-4.2c1.18,0,2.42,0.21,2.42,0.21v2.66h-1.36c-1.34,0-1.76,0.83-1.76,1.69v2.03h3\n\tl-0.48,3.12h-2.52v7.55C21.49,24.54,25.44,20.07,25.44,14.67z"}));
}

FacebookInline.defaultProps = {"version":"1.1","id":"Design","x":"0px","y":"0px","viewBox":"0 0 29.55 29.55","style":{"enableBackground":"new 0 0 29.55 29.55"},"xmlSpace":"preserve","className":"svg-fill"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
